const my_workbench = [
    { path: 'my-workbench/MyWorkbench', meta: { name: "我的工作台" } },

]

export default my_workbench



// WEBPACK FOOTER //
// ./src/router/mapping/my-workbench.js